import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { LoadingButton } from '@mui/lab';
import { Button, Grid, MenuItem, TextField } from '@mui/material';
import React, { useMemo, useState } from 'react';

import OberonDialog from '~components/OberonDialog';

interface DownloadPublicHolidayModalProps {
  open: boolean;
  onClose: () => void;
  onDownload: (year: number) => Promise<void>;
}

const DownloadPublicHolidayModal = ({ open, onClose, onDownload }: DownloadPublicHolidayModalProps) => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const yearList = useMemo(() => {
    const years: number[] = [];
    for (let year = currentYear; year >= 1900; year--) {
      years.push(year);
    }
    return years;
  }, [currentYear]);

  const handleDownload = async () => {
    setSubmitting(true);
    try {
      await onDownload(selectedYear);
      onClose();
    } catch (e) {
      // Error handled upstream via pushNotification
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <OberonDialog
      title='Download Public Holidays'
      open={open}
      content={
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              select
              fullWidth
              variant='outlined'
              label='Year'
              disabled={submitting}
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}>
              {yearList.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      }
      actionFooter={
        <>
          <Button variant='text' disabled={submitting} onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton
            onClick={handleDownload}
            variant='contained'
            disableElevation
            color='primary'
            disabled={submitting}
            loading={submitting}
            startIcon={<CloudDownloadIcon />}>
            Download
          </LoadingButton>
        </>
      }
    />
  );
};

export default DownloadPublicHolidayModal;
